import React from 'react';
import './utils/configureProductionConsole';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LanguageProvider } from './i18n/LanguageContext';
import { AppDialogProvider } from './components/AppDialog';
import AppUpdateGate from './components/AppUpdateGate';
import { getStoredThemePreference, resolveThemePreference } from './utils/themePreference';
import { Capacitor } from '@capacitor/core';
import { AnalyticsConsentBanner } from './components/AnalyticsConsent';
import { initializeAnalytics } from './services/analyticsService';

initializeAnalytics();

// React mount öncesi flash önleme — body arka planını hemen ayarla
// Kullanıcı seçim yaptıysa onu, yapmadıysa cihazın o anki temasını uygula.
;(function () {
  try {
    const platform = Capacitor.getPlatform();
    document.documentElement.dataset.platform = platform;
    document.body.dataset.platform = platform;
    const tema = resolveThemePreference(getStoredThemePreference());
    const bg = tema === 'light' ? '#f0f4ff' : '#1f2852';
    document.documentElement.style.backgroundColor = bg;
    document.body.style.backgroundColor = bg;
    document.documentElement.dataset.tema = tema;
    document.body.dataset.tema = tema;
    document.documentElement.style.colorScheme = tema === 'light' ? 'light' : 'dark';
    document.body.style.colorScheme = tema === 'light' ? 'light' : 'dark';
  } catch (_) {}
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <AppDialogProvider>
        <App />
        <AnalyticsConsentBanner />
        <AppUpdateGate />
      </AppDialogProvider>
    </LanguageProvider>
  </React.StrictMode>
);

reportWebVitals();
